<section class="table-section">
  <!-- MESSAGE -->
  <p-toast></p-toast>

  <div class="card">
    <!-- TABLE TOOLBAR SECTION -->
    <p-toolbar styleClass="mb-0">
      <ng-template pTemplate="left">
        <button
          pButton
          pRipple
          [pTooltip]="getNewButtonTooltip()"
          *CanPerformAction="options?.permissions?.add"
          [label]="getNewButtonLabel()"
          icon="pi pi-plus"
          class="p-button-success addBtn"
          (click)="openNew()"
        ></button>
        <button
          pButton
          pRipple
          [pTooltip]="'DATATABLE.DELETE_SELECTED_ITEMS' | translate"
          *CanPerformAction="options?.permissions?.delete"
          [label]="'DATATABLE.DELETE_SELECTED' | translate"
          icon="pi pi-trash"
          class="p-button-danger ml-2"
          (click)="deleteSelectedItems()"
          [disabled]="!selectedItems || !selectedItems.length"
        ></button>
      </ng-template>

      <ng-template pTemplate="right">
        <p-fileUpload
          mode="basic"
          *CanPerformAction="options?.permissions?.add"
          accept=".xlsx"
          (onSelect)="importData($event)"
          [auto]="true"
          [maxFileSize]="1000000"
          [label]="'DATATABLE.IMPORT' | translate"
          icon="pi pi-upload"
          [pTooltip]="'DATATABLE.IMPORT' | translate"
          [chooseLabel]="'DATATABLE.IMPORT' | translate"
          class="mr-2 inline-block"
        ></p-fileUpload>
        <button
          pButton
          pRipple
          [pTooltip]="'DATATABLE.EXPORT' | translate"
          [label]="'DATATABLE.EXPORT' | translate"
          icon="pi pi-download"
          class="p-button-help"
          (click)="exportData($event)"
        ></button>
      </ng-template>
    </p-toolbar>
    <!-- END OF TABLE TOOLBAR SECTION -->

    <div class="flex items-center justify-center" *ngIf="loading">
      <app-loader></app-loader>
    </div>

    <!-- DATA TABLE SECTION -->
    <p-table
      #dt
      [value]="tableData"
      *CanPerformAction="options.permissions.viewAll"
      [rows]="rows"
      [paginator]="true"
      (onPage)="pageChange($event)"
      [rowsPerPageOptions]="getRowsPerPageOptions()"
      [first]="first"
      [globalFilterFields]="headings"
      responsiveLayout="scroll"
      [(selection)]="selectedItems"
      [rowHover]="true"
      dataKey="id"
      [currentPageReportTemplate]="getPaginationTemplate()"
      [showCurrentPageReport]="true"
      [columns]="formatedHeadings"
      [totalRecords]="totalRecords"
    >
      <!-- TABLE CAPTION SECTION -->
      <ng-template pTemplate="caption">
        <div class="flex justify-between items-center justify-content-between">
          <h5 class="m-0">{{ getManageTitle() }}</h5>
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              #inputData
              (input)="dt.filterGlobal(inputData.value, 'contains')"
              [placeholder]="getSearchPlaceholder()"
            />
          </span>
        </div>
      </ng-template>

      <!-- TABLE HEADER SECTION -->
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th
            *ngFor="let header of sortHeaderItems"
            pSortableColumn="{{ header }}"
            [ngStyle]="{ width: 100 / sortHeaderItems.length + '%' }"
          >
            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              "
              >{{ header | columnTranslate }}</span
            >
            <p-sortIcon field="{{ header }}"></p-sortIcon>
          </th>
          <th *ngIf="options?.menu">{{ "COMMON.ACTIONS" | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>

          <td
            *ngFor="let col of formatedHeadings; index as i"
            (click)="viewDetailsPage(rowData)"
            [ngStyle]="{
              width:
                currentWidth >= 769
                  ? 100 / formatedHeadings.length + '%'
                  : '100%'
            }"
          >
            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: flex;
                justify-content: space-between;
              "
              *ngIf="possibleDates.includes(col.field.toLowerCase())"
            >
              <strong
                style="text-transform: capitalize"
                [hidden]="currentWidth > 768"
                >{{ col.field | columnTranslate }}
              </strong>
              <span
                class="text-capitalize"
                style="
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  width: 70%;
                "
                >{{ rowData[col.field] | date : "medium" }}</span
              >
            </span>

            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: flex;
                justify-content: space-between;
              "
              *ngIf="checkDataType(rowData[col.field], 'object')"
            >
              <strong
                style="text-transform: capitalize"
                [hidden]="currentWidth > 768"
                >{{ col.field | columnTranslate }}
              </strong>
              <span
                class="text-capitalize"
                style="
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  width: 70%;
                "
                >{{
                  rowData[col.field]?.name ?? rowData[col.field]?.title
                }}</span
              >
            </span>

            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: flex;
                justify-content: space-between;
              "
              *ngIf="col.field.toLowerCase() === 'description'"
            >
              <strong
                style="text-transform: capitalize"
                [hidden]="currentWidth > 768"
                >{{ col.field | columnTranslate }}
              </strong>
              <span
                class="text-capitalize"
                style="
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  width: 70%;
                "
                >{{ rowData[col.field] }}</span
              >
            </span>

            <img
              *ngIf="possibleImgElements.includes(col.field.toLowerCase())"
              [src]="rowData[col.field]"
              [alt]="rowData[col.field]"
              width="50"
              style="border-radius: 50%"
              class="shadow-4 rounded-full"
            />

            <!-- PLEASE REVISIT AND REVIEW THIS -->
            <span
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: flex;
                justify-content: space-between;
              "
              *ngIf="
                !possibleDates.includes(col.field.toLowerCase()) &&
                !possibleImgElements.includes(col.field.toLowerCase()) &&
                col.field.toLowerCase() !== 'description' &&
                !checkDataType(rowData[col.field], 'object')
              "
            >
              <strong
                style="text-transform: capitalize"
                [hidden]="currentWidth > 768"
                >{{ col.field | columnTranslate }}
              </strong>
              <span
                class="text-capitalize"
                style="
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  width: 70%;
                "
                >{{ rowData[col.field] }}</span
              >
            </span>
          </td>

          <td class="action-btn" *ngIf="options?.menu">
            <span *ngIf="options?.menu" class="targeted relative">
              <ng-template #menuParent></ng-template>
              <p-button
                [style]="{ width: '2rem', height: '2rem' }"
                (click)="menu.toggle($event)"
                icon="pi pi-ellipsis-v"
              >
              </p-button>
              <p-menu
                #menu
                [model]="[defaultMenu].concat(options.menu)"
                [popup]="true"
                (onShow)="triggerOnRowClick(rowData)"
                [appendTo]="menuParent"
              >
              </p-menu>
            </span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          {{ "DATATABLE.IN_TOTAL_THERE_ARE" | translate }}
          {{ tableData ? tableData.length : 0 }}
          {{ getNewButtonLabelOptions("plural") | titlecase }}.
        </div>
      </ng-template>
    </p-table>
    <!-- END OF DATA TABLE SECTION -->
  </div>

  <!-- NEW/EDIT TABLE DATA SECTION -->
  <p-dialog
    [(visible)]="dataDialog"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '90vw', maxWidth: '800px' }"
    [contentStyle]="{ maxHeight: '70vh', overflow: 'auto' }"
    class="p-fluid"
    [header]="
      (editable ? ('DATATABLE.EDIT' | translate) + ' ' : '') +
      (options.name | titlecase | translate) +
      ' ' +
      ('DATATABLE.DETAILS' | translate)
    "
    [modal]="true"
    styleClass="p-dialog-custom"
    (onHide)="hideDialog()"
  >
    <ng-template pTemplate="content">
      <div class="form-container">
        <div
          *ngFor="let formItem of formFields; index as index"
          class="form-field"
        >
          <!-- FILE INPUTS -->
          <div *ngIf="formItem?.type == 'file'" class="field col">
            <label *ngIf="editable" for="{{ formItem.field }}" class="pr-2">
              {{ formItem.field | columnTranslate }}
            </label>
            <p-fileUpload
              id="{{ index }}"
              [customUpload]="true"
              mode="basic"
              accept="image/*"
              (onSelect)="fileHandler($event, formItem.field)"
              [maxFileSize]="2000000"
              [chooseLabel]="formItem.field | columnTranslate"
              class="mr-2 inline-block"
            >
            </p-fileUpload>

            <img
              *ngIf="editable"
              [src]="formControls[formItem.field]"
              [alt]="formControls[formItem.field]"
            />

            <div
              *ngIf="!editable && selectedFiles.length > 0"
              class="img-fields"
            >
              <span *ngFor="let file of selectedFiles">
                <img
                  class="mt-4"
                  *ngIf="file.field == formItem.field"
                  [src]="file.file | safeImageUrl"
                  [alt]="formControls[formItem.field]"
                />
              </span>
            </div>
            <small class="p-error" *ngIf="submitted && !formItem.field"
              >{{ formItem.field | columnTranslate }} {{ "VALIDATION.REQUIRED" | translate | lowercase }}.</small
            >
          </div>

          <!-- TEXT INPUTS -->
          <div *ngIf="formItem?.type == 'text'" class="p-field">
            <label [for]="formItem.field">{{
              formItem.field | columnTranslate
            }}</label>
            <input
              type="text"
              pInputText
              [id]="formItem.field"
              [(ngModel)]="formControls[formItem.field]"
              [readonly]="inViewMode"
              [required]="formItem.validators?.includes('required')"
              [name]="formItem.field"
              [placeholder]="formItem.field | columnTranslate"
            />
            <small
              class="p-error"
              *ngIf="
                submitted &&
                !formControls[formItem.field] &&
                formItem.validators?.includes('required')
              "
            >
              {{ formItem.field | columnTranslate }}
              {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
            </small>
          </div>

          <!-- CALENDAR INPUTS -->
          <div *ngIf="formItem?.type == 'date'" class="p-field">
            <label [for]="formItem.field">{{
              formItem.field | columnTranslate
            }}</label>
            <p-calendar
              [id]="formItem.field"
              appendTo="body"
              [(ngModel)]="formControls[formItem.field]"
              [showIcon]="true"
              [readonlyInput]="true"
              [showButtonBar]="true"
              dateFormat="dd/mm/yy"
              [name]="formItem.field"
              [required]="formItem.validators?.includes('required')"
              [placeholder]="formItem.field | columnTranslate"
            >
            </p-calendar>
            <small
              class="p-error"
              *ngIf="
                submitted &&
                !formControls[formItem.field] &&
                formItem.validators?.includes('required')
              "
            >
              {{ formItem.field | columnTranslate }}
              {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
            </small>
          </div>

          <!-- TEXTAREA INPUTS -->
          <div *ngIf="formItem?.type == 'textarea'" class="p-field">
            <label [for]="formItem.field">{{
              formItem.field | columnTranslate
            }}</label>
            <textarea
              pInputTextarea
              [id]="formItem.field"
              [(ngModel)]="formControls[formItem.field]"
              [readonly]="inViewMode"
              [required]="formItem.validators?.includes('required')"
              [name]="formItem.field"
              [rows]="3"
              [placeholder]="formItem.field | columnTranslate"
            ></textarea>
            <small
              class="p-error"
              *ngIf="
                submitted &&
                !formControls[formItem.field] &&
                formItem.validators?.includes('required')
              "
            >
              {{ formItem.field | columnTranslate }}
              {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
            </small>
          </div>

          <!-- SELECT INPUTS -->
          <div *ngIf="formItem?.type == 'select'" class="field col">
            <div
              *ngIf="
                (loaderService._observer | async).isLoading &&
                  !selectOptions[formItem.field]?.length;
                else multiSelect
              "
            >
              {{ "DATATABLE.LOADING" | translate }}
              {{ selectOptions[formItem.field] }}
            </div>

            <ng-template #multiSelect>
              <label
                *ngIf="editable || inViewMode"
                for="{{ formItem.field }}"
                class="pr-2"
                >{{ formItem.field | columnTranslate }}</label
              >

              <p-multiSelect
                [options]="selectOptions[formItem.field]"
                display="chip"
                filter="true"
                filterBy="label"
                [ngModelOptions]="{ standalone: true }"
                [virtualScroll]="true"
                [placeholder]="formItem.field | columnTranslate"
                [emptyMessage]="'DATATABLE.NO_DATA_FOUND' | translate"
                [itemSize]="itemSize"
                [readonly]="inViewMode"
                [name]="formControls[formItem.field]"
                [(ngModel)]="formControls[formItem.field]"
                optionLabel="label"
                appendTo="body"
                optionValue="id"
                required
                #multiSelect="ngModel"
              >
              </p-multiSelect>

              <small
                class="p-error"
                *ngIf="
                  multiSelect.invalid &&
                  (multiSelect.dirty || multiSelect.touched)
                "
              >
                <span *ngIf="multiSelect.errors?.['required']">
                  {{ formItem.field | columnTranslate }}
                  {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
                </span>
              </small>
            </ng-template>
          </div>

          <!-- DROPDOWN (SINGLE SELECTION INPUTS) -->
          <div *ngIf="formItem?.type == 'dropdown'" class="field col">
            <div
              *ngIf="
                (loaderService._observer | async).isLoading &&
                  !selectOptions[formItem.field]?.length;
                else dropdownForm
              "
            >
              {{ "DATATABLE.LOADING" | translate }}
              {{ selectOptions[formItem.field] }}
            </div>

            <ng-template #dropdownForm>
              <label
                *ngIf="editable || inViewMode"
                for="{{ formItem.field }}"
                class="pr-2"
                >{{ formItem.field | columnTranslate }}</label
              >

              <p-dropdown appendTo="body"
                [(ngModel)]="formControls[formItem.field]"
                inputId="{{ index }}"
                [filter]="true"
                filterBy="label"
                [emptyMessage]="'DATATABLE.NO_DATA_FOUND' | translate"
                [options]="selectOptions[formItem.field]"
                [placeholder]="formItem.field | columnTranslate"
                optionLabel="label"
                [ngModelOptions]="{ standalone: true }"
                appendTo="body"
                required
                [name]="formControls[formItem.field]"
                #dropdown="ngModel"
                (onChange)="handleDropdownChange($event, formItem.field)"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    dropdown.invalid && (dropdown.touched || dropdown.dirty)
                }"
              >
              </p-dropdown>
              <small
                class="p-error"
                *ngIf="dropdown.invalid && (dropdown.touched || dropdown.dirty)"
              >
                <span *ngIf="dropdown.errors?.['required']">
                  {{ formItem.field | columnTranslate }}
                  {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
                </span>
              </small>
            </ng-template>
          </div>

          <!-- RADIO BUTTONS -->
          <div
            *ngIf="formItem?.type == 'radio'"
            class="field-radiobutton col-6"
          >
            <label for="{{ formItem.field }}" class="pr-2">{{
              formItem.field | columnTranslate
            }}</label>
            <p-radioButton
              id="{{ index }}"
              inputId="{{ index }}"
              [name]="formControls[formItem.field]"
              value="{{ formControls[formItem.field] }}"
              [(ngModel)]="formControls[formItem.field]"
              #radioButton="ngModel"
              [ngModelOptions]="{ standalone: true }"
              variant="filled"
              (onFocus)="toggleRadioBtn($event, formItem.field)"
            >
            </p-radioButton>
            <small
              class="p-error"
              *ngIf="
                radioButton.invalid &&
                (radioButton.dirty || radioButton.touched)
              "
            >
              <span *ngIf="radioButton.errors?.['required']">
                {{ formItem.field | columnTranslate }}
                {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
              </span>
            </small>
          </div>

          <!-- NUMBER INPUTS -->
          <div *ngIf="formItem?.type == 'number'" class="p-field">
            <label [for]="formItem.field">{{
              formItem.field | columnTranslate
            }}</label>
            <p-inputNumber
              [id]="formItem.field"
              [(ngModel)]="formControls[formItem.field]"
              [readonly]="inViewMode"
              [required]="formItem.validators?.includes('required')"
              [name]="formItem.field"
              [placeholder]="formItem.field | columnTranslate"
            ></p-inputNumber>
            <small
              class="p-error"
              *ngIf="
                submitted &&
                !formControls[formItem.field] &&
                formItem.validators?.includes('required')
              "
            >
              {{ formItem.field | columnTranslate }}
              {{ "VALIDATION.REQUIRED" | translate | lowercase }}.
            </small>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <button
        pButton
        pRipple
        [label]="
          inViewMode
            ? ('DATATABLE.CLOSE' | translate)
            : ('DATATABLE.CANCEL' | translate)
        "
        icon="pi pi-times"
        class="p-button-text"
        (click)="hideDialog()"
      ></button>
      <button
        *ngIf="!inViewMode"
        pButton
        pRipple
        [label]="'DATATABLE.SAVE' | translate"
        icon="pi pi-check"
        class="p-button-text"
        (click)="saveItem()"
      ></button>
    </ng-template>
  </p-dialog>
  <!-- END OF NEW/EDIT TABLE DATA SECTION -->

  <p-confirmDialog [style]="{ width: '50%' }"></p-confirmDialog>
</section>
